import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'components/Button';
import Paper from 'components/Paper';
import Input from 'components/Input';

const StyledLoginView = styled.div`
  ${Button} {
    margin-top: ${({ theme }) => theme.spacing * 2}px;
  }
`;

const LoginView = (
  {
    email, className, error, onSubmit, onChange, onForgotPasswordClick,
  },
) => {
  const classes = ['LoginView'];
  if (className) {
    classes.push(className);
  }

  const [password, setPassword] = useState('');

  const handleChange = (e) => {
    setPassword(e.target.value);
    if (onChange) onChange();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password) {
      onSubmit(password);
    }
  };

  return (
    <StyledLoginView className={classes.join(' ')}>
      <h1>Nearly done!</h1>
      <p>
        Please enter your password for
        <strong>
          {' '}
          {email}
          {' '}
        </strong>
        to complete your login
      </p>
      <Paper>
        <form onSubmit={handleSubmit} noValidate>
          <Input
            label="Password"
            type="password"
            placeholder="Enter your password"
            value={password}
            error={error}
            onChange={handleChange}
            focus
          />
          <Button
            type="submit"
            disabled={!password}
            fullWidth
            dataLayer={{ action: 'Login Portal', label: 'Log In' }}
          >
            Log in
          </Button>
          <Button
            type="button"
            inverse
            fullWidth
            onClick={onForgotPasswordClick}
            dataLayer={{ action: 'Login Portal', label: 'Forgot Password' }}
          >
            Forgot your password
          </Button>
        </form>
      </Paper>
    </StyledLoginView>
  );
};

LoginView.displayName = 'LoginView';

LoginView.propTypes = {
  email: PropTypes.string.isRequired,
  className: PropTypes.string,
  error: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  onForgotPasswordClick: PropTypes.func,
};

LoginView.defaultProps = {
  className: null,
  error: null,
  onChange: null,
  onForgotPasswordClick: null,
};

export default LoginView;
